import browser from './browser';
import Cookie from 'js-cookie';
import { getRootDomain } from './utils';

/**
 * 语言枚举
 */
export enum Language {
  /** 中文-简体 */
  ZH_CN = 'zh-CN',
  /** 中文-繁体 */
  ZH_TW = 'zh-TW',
  /** 英文-美国 */
  EN = 'en-US',
  /** 印尼文 */
  ID = 'id-ID',
}

/** 浏览器缓存的语言key */
const languageKey = 'ovo_language';

// 共享cookie的根域名
const DOMAIN_ROOT = getRootDomain();

/** 获取语言 */
export const getLanguage = () => {
  let lang = Cookie.get(languageKey) || '';
  if (browser.ovopark) {
    // 万店掌App userAgent标识: ovopark/{version}/{token}/{uuid}/{language}
    const matches = navigator.userAgent.match(/ovopark\/(\S+)?(?:\s|$)/);
    if (matches?.length) {
      lang = matches[1].split('/')[3] || '';
    }
  }
  if (!lang && browser.ios) {
    // ios特殊，从userAgent获取语言
    const matches = navigator.userAgent.match(/(Language|LarkLocale)\/(\S+)?(?:\s|$)/i);
    if (matches?.length) {
      lang = matches[2].replace('_', '-');
    }
  }
  if (!lang) {
    // 其他情况，从navigator获取语言
    lang = navigator.language;
  }

  if (lang.startsWith('en')) {
    return Language.EN;
  }
  if (lang.startsWith('id')) {
    return Language.ID;
  }
  if (/HK|TW|Hant/i.test(lang)) {
    return Language.ZH_TW;
  }
  if (lang.startsWith('zh')) {
    return Language.ZH_CN;
  }
  return lang;
};

/**
 * 设置语言
 * @param lang 显示语言
 */
export const setLanguage = (lang: string) => {
  Cookie.set(languageKey, lang, { domain: DOMAIN_ROOT });
};

// 时区偏移
let timeZone: string;
/** 获取GMT时区 */
export const getTimeZone = () => {
  if (!timeZone) {
    const timeZoneOffset = -new Date().getTimezoneOffset();
    const hour = timeZoneOffset / 60;
    const minute = timeZoneOffset % 60;
    timeZone = `GMT${hour >= 0 ? '+' : '-'}${Math.abs(hour).toString().padStart(2, '0')}:${minute
      .toString()
      .padStart(2, '0')}`;
  }
  return timeZone;
};
